import { AuthModalModel } from "./ModalControllers/AuthModalModel"
import { CopyModal } from "./ModalControllers/CopyModal"


class ModalController {
    private _authModal: AuthModalModel
    private _copy: CopyModal

    constructor(){
        this._authModal = new AuthModalModel()
        this._copy = new CopyModal()
    }

    get authModal(){
        return this._authModal
    }
    
    get copy(){
        return this._copy
    }
}

export { ModalController }